<template>
  <RevContainer>
    <section class="mb-96 flex flex-col gap-56 md:flex-row md:items-center">
      <div class="self-center">
        <RevIllustration
          :alt="i18n(translations.imageAlt)"
          :height="466"
          :src="imageUrl"
          :width="466"
        />
      </div>

      <div class="flex flex-col">
        <h1 class="heading-1 mb-24">
          {{ i18n(translations.title, { productName }) }}
        </h1>

        <div class="mb-32 flex flex-col gap-36 lg:flex-row lg:items-end">
          <div class="flex flex-col">
            <span class="label-large">{{ i18n(translations.upTo) }}</span>
            <span class="punchline">{{ i18n.price(price) }}</span>
          </div>
          <RevButton variant="primary" @click="emit('navigate-to-funnel')">{{
            i18n(translations.button)
          }}</RevButton>
        </div>

        <ul class="grid list-none grid-cols-2 gap-16">
          <li class="flex items-center gap-12 py-12">
            <div class="bg-surface-brand-hi rounded-md p-8">
              <IconMedal class="mood-blush" size="medium" />
            </div>
            <span class="text-static-default-hi body-2 text-center">
              {{ i18n(translations.medal) }}</span
            >
          </li>

          <li class="flex items-center gap-12 py-12">
            <div class="bg-surface-brand-hi rounded-md p-8">
              <IconMoney class="mood-blush" size="medium" />
            </div>
            <span class="text-static-default-hi body-2 text-center">
              {{ i18n(translations.money) }}
            </span>
          </li>
          <li class="flex items-center gap-12 py-12">
            <div class="bg-surface-brand-hi rounded-md p-8">
              <IconOfficial class="mood-blush" size="medium" />
            </div>
            <span class="text-static-default-hi body-2 text-center">
              {{ i18n(translations.official) }}
            </span>
          </li>

          <li class="flex items-center gap-12 py-12">
            <div class="bg-surface-brand-hi rounded-md p-8">
              <IconTruck class="mood-blush" size="medium" />
            </div>
            <span class="text-static-default-hi body-2 text-center">
              {{ i18n(translations.truck) }}
            </span>
          </li>
        </ul>
      </div>
    </section>
  </RevContainer>
</template>

<script setup lang="ts">
import type { Price } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'
import { IconMedal } from '@ds/icons/IconMedal'
import { IconMoney } from '@ds/icons/IconMoney'
import { IconOfficial } from '@ds/icons/IconOfficial'
import { IconTruck } from '@ds/icons/IconTruck'

import translations from './SeoHero.translations'

withDefaults(
  defineProps<{
    productName: string
    price: Price
    imageUrl?: string
  }>(),
  {
    imageUrl: '/img/buyback/product-default.jpg',
  },
)

const emit = defineEmits(['navigate-to-funnel'])

const i18n = useI18n()
</script>
